var $0ab437f467150cd9$exports = {};
$0ab437f467150cd9$exports = {
    "collectionLabel": `Sugerencias`
};


export {$0ab437f467150cd9$exports as default};
//# sourceMappingURL=es-ES.module.js.map
